import React from 'react';
import ModalPopup from '../ModalPopup';
import GlobalMessagePopup from '../GlobalMessagePopup';
import {useGlobalMessageContext} from '../../core/GlobalMessageContext';

const GlobalMessage = () => {
  const context = useGlobalMessageContext();

  return (
    <ModalPopup isOpen={context.isOpen}>
      <GlobalMessagePopup
        message={context.message}
        onClick={context.close}
      />
    </ModalPopup>
  );
};

export default GlobalMessage;
